import { useNavigate } from "react-router-dom";
import SearchBox from "../common/SearchBox";
import { useEffect, useCallback } from "react";
import { store } from "src/App";
import { SEARCHPAGE_ETFS_GET_REQUEST } from 'src/actions/etfs';
import { Helmet } from "react-helmet-async";
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
const Typical: any = require('react-typical').default;

export const MainPage: React.FunctionComponent = () => {
    const navigate = useNavigate();

    useEffect(() => {
        store.dispatch({ type: SEARCHPAGE_ETFS_GET_REQUEST });
    }, []);

    const onSearchboxEnter = useCallback((query: string): void => {
        if (query && query !== "") {
            navigate(`/search?query=${query}`);
        } else {
            navigate(`/search`);
        }
    }, [navigate]);

    const onLoadByAssetClass = useCallback((e: any) => {
        const assetClass = e.target.value;
        const cleanAssetClass = assetClass.replace(" ", "+");
        navigate(`/search?assetClass=${cleanAssetClass}`);
    }, [navigate]);

    return (
        <div>
            <Helmet>
                <title>Find, analyse and trade ETFs | inETF</title>
                <meta name="description" content="inETF is a platform for ETFs made by bmpi AG, powered by Cinnamon Reporting." />
                <link rel="canonical" href={process.env.REACT_APP_RESSOURCE_URL} />
            </Helmet>
            <Box sx={{
                marginTop: 10,
                textAlign: 'center',
                height: "10rem"
            }}>
                <Typography sx={{
                    fontSize: 96,
                    fontWeight: 500
                }}>
                    inETF
                </Typography>
                <Typography variant="h3">
                    <Typical
                        steps={['find.', 2000, 'analyse.', 2000, "trade.", 2000]}
                        loop={Infinity}
                        wrapper="span"
                    />
                </Typography>
            </Box>
            <Box sx={{
                marginTop: 10,
                marginBottom: 10,
                mx: "auto",
                width: "auto",
                maxWidth: "40rem",
            }}>
                <SearchBox onEnter={onSearchboxEnter} />
            </Box>
            <Box sx={{
                marginBottom: 12.5,
                mx: "auto",
                width: "auto",
                maxWidth: "40rem"
            }}>
                <Typography variant="body2" sx={{ marginBottom: 2 }}>By asset class</Typography>
                <Grid container columnSpacing={2} rowSpacing={{ xs: 2, md: 2 }}>
                    <Grid item xs={6} sm={4}>
                        <Button className="CinnamonButton" value="Equity" sx={{ width: "100%", textTransform: "none", height: "5rem" }} onClick={onLoadByAssetClass} variant="outlined" disableElevation>Equity</Button>
                    </Grid>
                    <Grid item xs={6} sm={4}>
                        <Button className="CinnamonButton" value="Fixed Income" sx={{ width: "100%", textTransform: "none", height: "5rem" }} onClick={onLoadByAssetClass} variant="outlined" disableElevation>Fixed Income</Button>
                    </Grid>
                    <Grid item xs={6} sm={4}>
                        <Button className="CinnamonButton" value="Commodity" sx={{ width: "100%", textTransform: "none", height: "5rem" }} onClick={onLoadByAssetClass} variant="outlined" disableElevation>Commodity</Button>
                    </Grid>
                    <Grid item xs={6} sm={4}>
                        <Button className="CinnamonButton" value="Currency" sx={{ width: "100%", textTransform: "none", height: "5rem" }} onClick={onLoadByAssetClass} variant="outlined" disableElevation>Currency</Button>
                    </Grid>
                    <Grid item xs={6} sm={4}>
                        <Button className="CinnamonButton" value="Real Estate" sx={{ width: "100%", textTransform: "none", height: "5rem" }} onClick={onLoadByAssetClass} variant="outlined" disableElevation>Real Estate</Button>
                    </Grid>
                    <Grid item xs={6} sm={4}>
                        <Button className="CinnamonButton" value="Alternative Investments" sx={{ width: "100%", textTransform: "none", height: "5rem" }} onClick={onLoadByAssetClass} variant="outlined" disableElevation>Alternative<br />Investments</Button>
                    </Grid>
                </Grid>
            </Box>
        </div>
    );
}

export default MainPage;